import { coreClient, apiRequest } from '../client.js';
import type { SupportedBotName } from '@discord-bot-platform/service-client';

export type ConversationConfig = {
  policyType: 'open' | 'intruder_detection' | 'whitelist';
  windowSize: number;
  maxChars?: number;
  multiUserMode: boolean;
};

export const conversationsApi = {
  getConfig: (guildId: string, botName: SupportedBotName) =>
    apiRequest<ConversationConfig>(coreClient, {
      method: 'GET',
      url: `/conversations/config/${guildId}/${botName}`,
    }),

  updateConfig: (guildId: string, botName: SupportedBotName, config: Partial<ConversationConfig>) =>
    apiRequest<ConversationConfig>(coreClient, {
      method: 'PATCH',
      url: `/conversations/config/${guildId}/${botName}`,
      data: config,
    }),
};

export default conversationsApi;
